import CommentIcon from '../images/chat.png';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "./whatsappus.css";

const WhatsAppUs = () => {

    return (
        <>
        {/* data-aos="slide-left" */}
            <span className="icon">
                <a href='https://wa.link/d9n8np' target="_blank">
                    <img src={CommentIcon} alt="comment icon" />
                </a>
            </span>
        </>
    )
}

export default WhatsAppUs